import type { EventInput } from "@fullcalendar/core";

import type { FullEvent } from "@ctrl/controller-rpc";

import { buildEventTime } from "../helpers/build-event-time";

const mirrorEventId = "mirrorEventId";

export const buildAggregatedEvent = (
  id: string,
  title: string,
  calendarId: string,
  allDay: boolean,
  start: Date,
  end: Date
): FullEvent => {
  return {
    active: true,
    allDay,
    attendable: false,
    available: allDay ? "free" : "busy",
    calendar: calendarId,
    draft: true,
    editable: false,
    end,
    id,
    isArchived: false,
    movable: false,
    start,
    time: buildEventTime(allDay, start, end),
    title,
  };
};

export const buildDraftTaskEvent = (
  id: string,
  title: string,
  defaultCalendarId: string,
  allDay: boolean,
  start: Date,
  end: Date,
  task: string | undefined
): FullEvent => {
  return {
    active: true,
    allDay,
    attendable: false,
    available: allDay ? "free" : "busy",
    calendar: defaultCalendarId,
    draft: true,
    editable: false,
    end,
    id,
    isArchived: false,
    movable: false,
    start,
    task,
    time: buildEventTime(allDay, start, end),
    title,
  };
};

export const buildMirrorEvent = (
  title: string,
  defaultCalendarId: string,
  allDay: boolean,
  start: Date,
  end: Date
): FullEvent => {
  return {
    active: true,
    allDay,
    attendable: false,
    available: allDay ? "free" : "busy",
    calendar: defaultCalendarId,
    draft: true,
    editable: false,
    end,
    id: mirrorEventId,
    isArchived: false,
    movable: false,
    start,
    time: buildEventTime(allDay, start, end),
    title,
  };
};

export const createDraftTaskEventInput = (
  id: string,
  title: string
): EventInput => {
  return {
    id,
    title,
    duration: "00:30",
  };
};
